// src/store/modules/strategy/actions.js

import { get,post } from '@/services/api';
export default {
  async fetchOptionChain(_, payload) {
    console.log(`📦 Fetching option chain | payload=${payload}`);
    try {
      const response = await post(`/indicators/refresh-option-chain`, payload);
      console.log('📦 Fetch Option Chain API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Option Chain API error:', error);
      throw error;
    }
  },
  async getNegativeTrade(_, payload) {
    console.log(`📦 Fetching negative trade | payload=${payload}`);
    try {
      const response = await get(`/indicators/get-negative-trade`, payload);
      console.log('📦 Fetch Negative Trade API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Negative Trade API error:', error);
      throw error;
    }
  },
  async getPositiveTrade(_, payload) {
    console.log(`📦 Fetching positive trade | payload=${payload}`);
    try {
      const response = await get(`/indicators/get-positive-trade`, payload);
      console.log('📦 Fetch Positive Trade API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Positive Trade API error:', error);
      throw error;
    }
  },
  async getDeltaManagementTrade(_, payload) {
    console.log(`📦 Fetching Delta trade | payload=${payload.horizon}`);
    try {
      const response = await get('/indicators/get-delta-management-trade', {
        params: {
          horizon: payload.horizon,
        },
      });
      console.log('📦 Fetch Delta Trade API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Delta Trade API error:', error);
      throw error;
    }
  },

};
